module.exports = __webpack_public_path__ + "img/sb-token.9ffd1db5.png";